import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Select from "./common/select";
import Input from "./common/input";
import SiteTable from "./constantsSiteTable";
import CorpTable from "./constantsCorpTable";
import Pagination from "./common/pagination";
import Loading from "../components/common/loading";

import http from "../services/http";
import { paginate } from "../utils/paginate";
import UserContext from "../context/userContext";
import SidebarContext from "../context/sidebarContext";

const Constants = () => {
  const [user] = useContext(UserContext);
  const [sidebar] = useContext(SidebarContext);

  const [groups, setGroups] = useState([]);
  const [activeGroup, setActiveGroup] = useState("");
  const [constants, setConstants] = useState([]);
  const [constantValue, setConstantValue] = useState("");
  const [parameter, setParameter] = useState("");
  const [show, setShow] = useState(false);
  const pageSize = 12;
  const navigation = '';
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getGroups() {
      const { data } = await http.get(`/parameter-groups`);
      setGroups(data);
    }
    getGroups();
    document.title = "FTR - Constants";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getParameters() {
      const group = activeGroup === "ALL" ? "" : `?group=${activeGroup}`;
      const endpoint =
        user.SITE === "CO" ? `/constants/global${group}` : `/constants${group}`;
      setLoading(true);
      const { data } = await http.get(endpoint);
      setLoading(false);
      setConstants(data);
    }
    if (user && activeGroup !== "") {
      getParameters();
    }
  }, [activeGroup, user]);

  function handleEdit(p) {
    setConstantValue(p.CONSTANT_VALUE);
    setParameter(p.CODE);
    setShow(true);
  }

  async function handleUpdate(e) {
    e.preventDefault();

    const oldConstants = [...constants];
    const index = constants.map((p) => p.CODE).indexOf(parameter);
    const newConstants = [...constants];
    newConstants[index].CONSTANT_VALUE = constantValue;
    setConstants(newConstants);

    try {
      const body = { Value: constantValue };
      await http.patch(`/constants/${parameter}`, body);

      toast.success("Parameter Updated");
      setParameter("");
      setConstantValue("");
      setShow(false);
    } catch (ex) {
      setConstants(oldConstants);
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  function handleChange({ currentTarget: input }, index, field) {
    const newConstants = [...constants];
    newConstants[index][field] = input.value;
    setConstants(newConstants);
  }

  async function handleCorpUpdate(parm) {
    try {
      const body = {
        BU: parm.BU_CONSTANT,
        CA: parm.CA_CONSTANT,
        NE: parm.NE_CONSTANT,
        WI: parm.WI_CONSTANT,
      };
      await http.patch(`/constants/global/${parm.CODE}`, body);
      toast.success("Parameter Updated");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  let filtered = constants;
  if (query)
    filtered = constants.filter(
      (c) =>
        c.CODE.toUpperCase().includes(query.toUpperCase()) ||
        c.HEADING1.toUpperCase().includes(query.toUpperCase())
    );
  let data = paginate(filtered, currentPage, pageSize);

  return (
    <div className={sidebar ? "col-10 mt-4" : "col mt-4"}>
      <div className="row mx-5">
        <div className="col-3">
          <Select
            name="group"
            label="Parameter Group"
            placeholder="Group"
            value={activeGroup}
            options={[{ CODE: "ALL", DESCRIPTION: "All Constants" }, ...groups]}
            onChange={(e) => {
              setActiveGroup(e.target.value);
              setCurrentPage(1);
            }}
            listKey="CODE"
            listName="DESCRIPTION"
          />
        </div>
        <div className="col">
          <Input
            name="search-constants"
            label="Search"
            placeholder="Search Constants..."
            value={query}
            onChange={(e) => {
              setQuery(e.currentTarget.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="row mx-5">
          {user && user.SITE !== "CO" && (
            <SiteTable
              data={data}
              handleEdit={handleEdit}
              total={filtered.length}
            />
          )}
          {user && user.SITE === "CO" && (
            <CorpTable
              data={data}
              handleChange={handleChange}
              handleUpdate={handleCorpUpdate}
              total={filtered.length}
            />
          )}
          <Pagination
            itemsCount={filtered.length}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={(p) => setCurrentPage(p)}
            navigation={navigation}
          />
        </div>
      )}
      <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>Edit constant</Modal.Title>
      </Modal.Header>
        <Modal.Body>
          <Input
            name="CONSTANT_VALUE"
            label="Constant Value"
            placeholder="Value"
            value={constantValue}
            onChange={(e) => setConstantValue(e.target.value)}
            // error={errors.CONSTANT_VALUE}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Constants;
